import { isAxiosError } from "axios";
import { z } from "zod";
import {
	type LantechMachine,
	type LantechMachineRequest,
	lantechMachineSchema,
	prepareLantechMachineData,
} from "@packsize/schemas/machines";

import { packNetAxios } from "@/lib/api-client";

import { baseRoutes } from "../base-routes";

export async function createLantechCaseSealerMachine(data: LantechMachineRequest): Promise<void> {
	await packNetAxios.post(`${baseRoutes.lantechCaseSealer}/api/v1/machines`, data);
}

export async function updateLantechCaseSealerMachine(
	tenantId: string,
	machineId: string,
	data: LantechMachineRequest,
): Promise<void> {
	// TODO @eb: Remove machineId and tenantId from the payload when the backend no longer requires it.
	await packNetAxios.put(`${baseRoutes.lantechCaseSealer}/api/v1/machines/${machineId}`, {
		id: machineId,
		tenantId,
		...data,
	});
}

export async function getLantechCaseSealerMachines(): Promise<LantechMachine[]> {
	try {
		const response = await packNetAxios.get(`${baseRoutes.lantechCaseSealer}/api/v1/machines`);

		if (Array.isArray(response.data) === false) {
			throw new Error("Unable to fetch LantechCaseSealer machines, response is not a list");
		}

		return z
			.array(lantechMachineSchema)
			.enrich({ callSite: "getLantechCaseSealerMachines - v2" })
			.parseWithTelemetry(response.data.map(prepareLantechMachineData));
	} catch (error) {
		if (isAxiosError(error) && error.response?.status === 404) {
			return [];
		}

		throw error;
	}
}

export async function getLantechCaseSealerMachine(machineId: string): Promise<LantechMachine | null> {
	const response = await packNetAxios.get(`${baseRoutes.lantechCaseSealer}/api/v1/machines/${machineId}`);

	if (response.status !== 200) {
		return null;
	}

	return lantechMachineSchema
		.enrich({ callSite: "getLantechCaseSealerMachine - v2" })
		.parseWithTelemetry(prepareLantechMachineData(response.data));
}
